export default __webpack_public_path__ + "menu.f1757d2e1c928e76.svg";